import css from './style.module.scss';
import Wrap from '../Wrap';
import { gql } from '../../util/fetchGql';
import { useMemo } from 'react';
import A from '../A';
import tidyUri from '../../util/tidyUri';
import Image from 'next/image';

export const BRANDS_INDEX_FRAGMENT = gql`
	fragment BrandsIndex on Query {
		brands: entries (
			section: "brand"
			orderBy: "title asc"
		) {
			... on brand_default_Entry {
                id
                title
                uri
				images (limit: 1) {
					url @transform(
						width: 960
						height: 744
					)
				}
			}
		}
	}
`;

export default function BrandsIndex ({ brands }) {
	const perColumn = Math.ceil(brands.length / 4);
	const columns = useMemo(() => {
		const cols = [];
		let columnIndex = -1,
			activeChar = null,
			needsBreak = false;

		for (let i = 0, l = brands.length; i < l; i++) {
			if (i % perColumn === 0 && i !== 0)
				needsBreak = true;

			const brand = brands[i];
			const char = brand.title[0].toUpperCase();

			if (char !== activeChar) {
				activeChar = char;

				if (needsBreak || i === 0) {
					cols.push([activeChar]);
					columnIndex++;
					needsBreak = false;
				} else {
					cols[columnIndex].push(char);
				}
			}

			cols[columnIndex].push(brands[i]);
		}

		return cols;
	}, [brands, perColumn]);

	return (
		<Wrap className={css.brands}>
			{columns.map((col, i) => (
				<ul className={css.column} key={i}>
					{col.map(item => typeof item === 'string' ? (
						<h4 key={item}>{item}</h4>
					) : (
						<li key={item.id}>
							<A href={tidyUri(item.uri)}>
								<span>{item.title}</span>
								{item.images.length > 0 && (
									<div>
										<Image unoptimized
											src={item.images[0].url}
											width={320}
											height={248}
										/>
									</div>
								)}
							</A>
						</li>
					))}
				</ul>
			))}
		</Wrap>
	);
}
